// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1nOE6","list":"styles_list__iK4Pe"};